import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import React from "react";
import { ILicenseHistory } from "../ResellerClientRow/ResellerClientRow";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  license: ILicenseHistory;
  onClose: () => void;
  onConfirm: (quantityToRevoke: number) => void;
}

interface State {
  quantityToRevoke: string;
  error: string;
}

export class RevokeLicenseModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { quantityToRevoke: "1", error: "" };
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ quantityToRevoke: "1", error: "" });
    }
  }

  handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const availableToRevoke =
      this.props.license.quantityAssigned - this.props.license.quantityConsumed;

    if (Number(value) > availableToRevoke) {
      this.setState({
        error: `Máximo de ${availableToRevoke} licenças para revogar.`,
        quantityToRevoke: value,
      });
    } else if (Number(value) < 1 && value !== "") {
      this.setState({
        error: "A quantidade deve ser maior que zero.",
        quantityToRevoke: value,
      });
    } else {
      this.setState({ error: "", quantityToRevoke: value });
    }
  };

  handleConfirm = () => {
    if (!this.state.error) {
      this.props.onConfirm(Number(this.state.quantityToRevoke));
    }
  };

  render() {
    const { isOpen, isLoading, license, onClose } = this.props;
    const { quantityToRevoke, error } = this.state;
    const availableToRevoke =
      license.quantityAssigned - license.quantityConsumed;
    const canConfirm = !error && Number(quantityToRevoke) >= 1 && !isLoading;

    return (
      <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth variant="modal">
        <DialogTitle variant="modal">
          <RemoveCircleIcon />
          Revogar Licenças
        </DialogTitle>
        <DialogContent variant="modal">
          <Box display="flex" flexDirection="column" gap={1.5}>
            <Typography variant="body1">
              <strong>Instrumento:</strong> {license.instrumentName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Distribuídas: {license.quantityAssigned} | Consumidas: {license.quantityConsumed}
            </Typography>
            <Typography variant="body1" color="primary" fontWeight="bold">
              Disponível para revogar: {availableToRevoke}
            </Typography>

            <TextField
              fullWidth
              autoFocus
              label="Quantidade a revogar"
              type="number"
              value={quantityToRevoke}
              onChange={this.handleQuantityChange}
              error={!!error}
              helperText={error}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: availableToRevoke,
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions variant="modal" sx={{ justifyContent: "end", gap: 1 }}>
          <Button variant="outlined" color="error" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!canConfirm}
            onClick={this.handleConfirm}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Confirmar Revogação"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
